import I18n from '@legacy/js/vendor/I18n';

const $I18n = new I18n();

export default $I18n;
